import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SUPPORT_EMAIL = 'support@tuplecamp.com';

const ContactPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      q: "I didn't receive my course materials. What do I do?",
      a: `After payment, you should receive an email with a Google Drive link within a few minutes. Check your spam/promotions folder first. If you still don't see it, email us at ${SUPPORT_EMAIL} with your order ID and the email you used during purchase.`
    },
    {
      q: "How do I access my purchased materials?",
      a: "After successful payment, you'll receive an email with a Google Drive link. Click the link to access all materials. The folder will also appear in your Google Drive under 'Shared with me'."
    },
    {
      q: "What payment methods do you accept?",
      a: "We accept all major payment methods through Cashfree including UPI, Credit/Debit Cards, Net Banking, and Wallets."
    },
    {
      q: "Do you offer refunds?",
      a: "Due to the digital nature of our products, we don't offer refunds. However, we provide detailed product descriptions to help you make an informed decision before purchase."
    },
    {
      q: "My payment was deducted but I didn't get the materials. Help!",
      a: `Don't worry! Email us immediately at ${SUPPORT_EMAIL} with your order ID, payment screenshot, and email address. We'll verify and send your materials right away.`
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <h1>Need Help?</h1>
        <p>
          Having issues with your purchase or need assistance? We're here to help!
        </p>
      </div>

      <div className="contact-container">
        {/* Primary Support Section */}
        <div className="primary-support-section">
          <div className="support-card-main">
            <div className="support-icon">📧</div>
            <h2>Email Support</h2>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="support-email-link">
              {SUPPORT_EMAIL}
            </a>
            <p className="support-description">
              For any purchase issues, missing materials, or questions — just email us!
            </p>
            <div className="what-to-include">
              <h4>When emailing about a purchase issue, please include:</h4>
              <ul>
                <li>Your Order ID (starts with TC_)</li>
                <li>Email used during purchase</li>
                <li>Screenshot of payment confirmation (if applicable)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Response Time Notice */}
        <div className="response-notice">
          <p>
            We typically respond within <strong>2-4 hours</strong> during business hours (10 AM - 8 PM IST).
          </p>
        </div>

        {/* Contact Info Section */}
        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-card-icon">📍</div>
            <h3>Location</h3>
            <p>Pondicherry, India</p>
            <p className="contact-note">Serving students globally</p>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">🕐</div>
            <h3>Business Hours</h3>
            <p>Monday - Saturday: 10 AM - 8 PM IST</p>
            <p>Sunday: 12 PM - 6 PM IST</p>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="contact-faq-section">
          <h2>Common Questions</h2>
          <div className="contact-faq-list">
            {faqs.map((faq, i) => (
              <div
                className={`contact-faq-item ${openFaq === i ? 'open' : ''}`}
                key={i}
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <div className="contact-faq-question">
                  <span>{faq.q}</span>
                  <span className="contact-faq-toggle">{openFaq === i ? '−' : '+'}</span>
                </div>
                <div className="contact-faq-answer">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="quick-links-section">
          <h2>Quick Links</h2>
          <div className="quick-links-grid">
            <Link to="/#products">Pricing</Link>
            <Link to="/#faq">FAQ</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms and Conditions</Link>
          </div>
        </div>

        {/* Business Information */}
        <div className="business-info-section">
          <h2>Business Information</h2>
          <div className="business-info-grid">
            <div className="business-info-item">
              <span className="info-label">Business Name</span>
              <span className="info-value">Tuple Camp</span>
            </div>
            <div className="business-info-item">
              <span className="info-label">Type</span>
              <span className="info-value">Educational Services</span>
            </div>
            <div className="business-info-item">
              <span className="info-label">Founded</span>
              <span className="info-value">2025</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
